/* Lewd E-Girl Bondage: OnlyLewds homepage polaroid section (Madds). Steven 2026-09-27, cloned from the Gothic Maid section.
   A 16 s film (her graded 4K clips + code-drawn bind / develop / tied-up / signature beats, Mirelo SFX + Stable Audio e-girl trap) plays inside a
   giant instant photo. Tap the film to fire the flash; "Take her Polaroid" snaps the current frame into a print that ejects and
   develops (faster when you shake it). Sound is off until the visitor asks for it. */
(() => {
  const $ = id => document.getElementById(id);
  const root = $('mb-club'); if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- marquee + scalloped edge ----------
  const lip = '<svg viewBox="0 0 64 64" aria-hidden="true"><use href="#mbSpider"/></svg>';
  const words = ['LEWD E-GIRL BONDAGE', 'SIGNED MADS ♡', 'ONE OF ONE', 'BLACK FRAME', 'WHITE FRAME', 'TAPED UP', 'NO REPRINTS'];
  const run = words.map(w => `<span>${w}</span>${lip}`).join('');
  $('mbTrack').innerHTML = run + run + run + run;
  (() => {
    let d = 'M0 34 L0 0'; const n = 12, w = 1200 / n;
    for (let i = 0; i < n; i++) { const x = i * w; d += ` Q${x + w * .25} 30 ${x + w * .5} 6 Q${x + w * .75} 30 ${x + w} 0`; }
    $('mbEdgePath').setAttribute('d', d + ' L1200 34 Z');
  })();

  const wrap = $('mbWrap'), film = $('mbFilm'), screen = $('mbScreen'), video = $('mbVideo');
  const flash = $('mbFlash'), bar = $('mbBar'), tc = $('mbTc'), soundBtn = $('mbSound'), snapBtn = $('mbSnap');

  // ---------- sound: the film carries the mix; the synth adds the shutter click on taps ----------
  const Sfx = {
    on: false, ctx: null,
    init() { try { this.ctx = this.ctx || new (window.AudioContext || window.webkitAudioContext)(); this.ctx.resume(); } catch (e) {} },
    click() {
      if (!this.on || !this.ctx) return; const c = this.ctx, t = c.currentTime;
      const b = c.createBuffer(1, c.sampleRate * .06, c.sampleRate), d = b.getChannelData(0);
      for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 3);
      const s = c.createBufferSource(), f = c.createBiquadFilter(), g = c.createGain(); s.buffer = b; f.type = 'bandpass'; f.frequency.value = 3200; f.Q.value = 1.2;
      g.gain.value = .5; s.connect(f); f.connect(g); g.connect(c.destination); s.start(t);
    },
    whirr(dur = .9) {
      if (!this.on || !this.ctx) return; const c = this.ctx, t = c.currentTime, o = c.createOscillator(), g = c.createGain(), f = c.createBiquadFilter();
      o.type = 'sawtooth'; o.frequency.setValueAtTime(90, t); o.frequency.linearRampToValueAtTime(140, t + dur); f.type = 'lowpass'; f.frequency.value = 900;
      g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(.05, t + .05); g.gain.setValueAtTime(.05, t + dur - .1); g.gain.linearRampToValueAtTime(0, t + dur);
      o.connect(f); f.connect(g); g.connect(c.destination); o.start(t); o.stop(t + dur);
    }
  };
  soundBtn.addEventListener('click', e => {
    e.stopPropagation(); Sfx.init(); Sfx.on = !Sfx.on; video.muted = !Sfx.on;
    if (Sfx.on) { video.currentTime = video.currentTime; video.play().catch(() => {}); }
    soundBtn.setAttribute('aria-pressed', Sfx.on); soundBtn.textContent = Sfx.on ? '🔊 Sound on' : '🔈 Sound off';
  });

  // ---------- lazy film: load + play only while the section is on screen ----------
  let loaded = false, inView = false;
  const small = matchMedia('(max-width:680px)').matches;
  function loadFilm() { if (loaded) return; loaded = true; video.src = (small ? video.dataset.srcSm : video.dataset.src) || video.dataset.src; video.load(); }
  new IntersectionObserver(es => {
    inView = es[0].isIntersecting;
    if (inView) { loadFilm(); if (!reduce) video.play().catch(() => {}); } else video.pause();
  }, { threshold: .25 }).observe(screen);
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (inView && !reduce) video.play().catch(() => {}); });

  // progress bar, timecode, and the frame turning white once the print is signed on the white frame
  const fmt = s => '00:' + String(Math.floor(s)).padStart(2, '0');
  video.addEventListener('timeupdate', () => {
    const d = video.duration || 16.04, t = video.currentTime;
    bar.style.width = (t / d * 100).toFixed(2) + '%'; tc.textContent = fmt(t);
    film.classList.toggle('is-white', t > 13.63);   // the set beat (all five prints, White 23 among them) starts at 13.63 s; her signature is on a BLACK frame
  });

  // ---------- tilt parallax on the giant polaroid ----------
  if (!reduce) {
    wrap.addEventListener('pointermove', e => {
      const r = film.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      film.style.transform = `rotateY(${(x * 8).toFixed(2)}deg) rotateX(${(-y * 6).toFixed(2)}deg)`;
    });
    wrap.addEventListener('pointerleave', () => { film.style.transform = ''; });
  }

  // ---------- flash ----------
  function fire() {
    if (!reduce) { flash.animate([{ opacity: .95 }, { opacity: 0 }], { duration: 420, easing: 'cubic-bezier(.2,.7,.3,1)' }); }
    Sfx.init(); Sfx.click();
  }

  // ---------- take her polaroid: snap the current frame into a print that ejects and develops ----------
  const drops = [];
  function snap() {
    fire(); Sfx.whirr();
    const card = document.createElement('div'); card.className = 'mb-drop' + (Math.random() < .5 ? ' is-black' : '');
    const cv = document.createElement('canvas'); cv.width = 400; cv.height = 400;
    const cx = cv.getContext('2d');
    try {
      if (video.readyState >= 2) cx.drawImage(video, 0, 0, 400, 400);
      else { const im = new Image(); im.onload = () => cx.drawImage(im, 0, 0, 400, 400); im.src = video.poster; }
    } catch (e) {}
    const lbl = document.createElement('small'); lbl.textContent = 'Mads ♡';
    const tag = document.createElement('b'); tag.textContent = 'DEVELOPING';
    card.append(cv, lbl, tag);
    cv.style.cssText = 'display:block;width:100%;aspect-ratio:1/1;filter:brightness(.22) saturate(.1) hue-rotate(160deg) contrast(.7)';
    document.body.appendChild(card);
    // eject from under the giant polaroid
    const r = film.getBoundingClientRect(), w = Math.min(170, innerWidth * .38);
    card.style.width = w + 'px';
    const sx = scrollX, sy = scrollY, x0 = sx + r.left + r.width / 2 - w / 2, y0 = sy + r.bottom - w * .9;
    const tx = Math.max(sx + 8, Math.min(sx + innerWidth - w - 8, x0 + (Math.random() - .5) * r.width * .9)), ty = sy + r.bottom - 10 + Math.random() * 30;
    card.style.left = x0 + 'px'; card.style.top = y0 + 'px'; card.style.transform = 'scale(.6)'; card.style.opacity = '0';
    requestAnimationFrame(() => { card.style.opacity = '1'; card.style.left = tx + 'px'; card.style.top = ty + 'px'; card.style.transform = `rotate(${(Math.random() * 16 - 8).toFixed(1)}deg)`; });
    // develop: 0 -> 1 over ~6 s, much faster while being shaken
    let dev = 0, last = performance.now(), shake = 0;
    const step = now => {
      const dt = Math.min(.05, (now - last) / 1000); last = now;
      dev = Math.min(1, dev + dt / 6 + shake * dt * 1.4); shake *= .9;
      cv.style.filter = `brightness(${.22 + .78 * dev}) saturate(${.1 + .9 * dev}) hue-rotate(${(160 * (1 - dev)).toFixed(0)}deg) contrast(${.7 + .3 * dev})`;
      if (dev < 1 && card.isConnected) requestAnimationFrame(step); else tag.remove();
    };
    requestAnimationFrame(step);
    // drag + shake
    let drag = null, pv = null;
    card.addEventListener('pointerdown', e => { drag = { x: e.clientX - card.offsetLeft, y: e.clientY - card.offsetTop }; pv = { x: e.clientX, y: e.clientY }; card.setPointerCapture(e.pointerId); card.style.transition = 'none'; card.style.cursor = 'grabbing'; });
    card.addEventListener('pointermove', e => {
      if (!drag) return; card.style.left = (e.clientX - drag.x) + 'px'; card.style.top = (e.clientY - drag.y) + 'px';
      shake = Math.min(12, shake + Math.hypot(e.clientX - pv.x, e.clientY - pv.y) / 30); pv = { x: e.clientX, y: e.clientY };
    });
    card.addEventListener('pointerup', () => { drag = null; card.style.cursor = 'grab'; });
    card.addEventListener('dblclick', () => card.remove());
    drops.push(card); if (drops.length > 4) drops.shift().remove();
  }
  snapBtn.addEventListener('click', snap);
  // Steven 09-25: a tap on the film does the same as the button: flash, click, and her Polaroid of that exact moment ejects
  screen.addEventListener('click', e => { if (e.target.closest('.mb-sound')) return; snap(); });
  // prints are page furniture: clear them when the section scrolls well out of view
  new IntersectionObserver(es => { if (!es[0].isIntersecting) { drops.splice(0).forEach(d => d.remove()); } }, { rootMargin: '200px' }).observe(root);
})();
